import { render, staticRenderFns } from "./OrgUserTagSelectList.vue?vue&type=template&id=10a61d65&scoped=true";
import script from "./OrgUserTagSelectList.vue?vue&type=script&lang=js";
export * from "./OrgUserTagSelectList.vue?vue&type=script&lang=js";
import style0 from "./OrgUserTagSelectList.vue?vue&type=style&index=0&id=10a61d65&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "10a61d65", null);
export default component.exports;